import { defineComponent as _defineComponent } from 'vue'
import {
  computed,
  StyleValue,
  withDefaults,
} from 'vue';

interface Props {
  size?: 'large' | 'default';
  type?: 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'text';
  customStyle?: StyleValue;
  loading?: boolean;
  disabled?: boolean;
  round?: boolean;
  plain?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    size: { default: undefined },
    type: { default: undefined },
    customStyle: { default: () => ({}) },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    round: { type: Boolean, default: true },
    plain: { type: Boolean, default: false }
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as { size: 'large' | 'default', type: 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'text', customStyle: StyleValue, loading: boolean, disabled: boolean, round: boolean, plain: boolean };





function handleClick(event: MouseEvent) {
  if (!props.disabled) {
    emit('click', event);
  }
}

const buttonClassList = computed(() => [
  'tui-button',
  `tui-button-${props.type}`,
  `tui-button-${props.size}`,
  { 'tui-button-round': props.round },
  { 'tui-button-loading': props.loading },
  { 'tui-button-disabled': props.disabled },
  { 'tui-button-plain': props.plain },
]);

return { __sfc: true,props, emit, handleClick, buttonClassList }
}

})